import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import vuetify from './plugins/vuetify'
import CKEditor from 'ckeditor4-vue/dist/legacy.js'

// Polyfill
import 'core-js/stable'
import "regenerator-runtime/runtime"
import VueI18n from "vue-i18n";

Vue.config.productionTip = false
Vue.use(CKEditor)
Vue.use(VueI18n)

import {messagesI18n as messages} from "@/messagesI18n";
const i18n = new VueI18n({
  locale: 'ja',
  messages,
})

new Vue({
  router,
  vuetify,
  render: h => h(App),
  i18n
}).$mount('#app')


